import API from '@/api/api'

const defaultData = {
  order     : 'name', // name, stationcount
  reverse   : false,
  offset    : 0,
  limit     : 100_000,
  hidebroken: true
}

export default {
  async getAll (data = {}, config = {}) {
    const endpoint = API.endpointConfig.state.getAll

    const payload = { ...defaultData, ...data }
    const configuration = { ...config }
    return await API.restRequest(endpoint, payload, configuration)
  },

  async getByFilter (filter, data = {}, config = {}) {
    const endpoint = API.endpointConfig.state.getByFilter
    endpoint.path = endpoint.path.replace('{filter}', filter || '')

    const payload = { ...defaultData, ...data }
    const configuration = { ...config }
    return await API.restRequest(endpoint, payload, configuration)
  },

  async getByCountry (country, filter, data = {}, config = {}) {
    const endpoint = API.endpointConfig.state.getByCountry
    endpoint.path = endpoint.path.replace('{country}', country || '')
    endpoint.path = endpoint.path.replace('{filter}', filter || '')

    const payload = { ...defaultData, ...data }
    const configuration = { ...config }
    return await API.restRequest(endpoint, payload, configuration)
  }
}
